export function combineLocalDateAndTimeToIso(date: Date, time: Date): string {
  const appointmentDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    time.getHours(),
    time.getMinutes(),
    0,
    0
  );

  return appointmentDate.toISOString();
}

export function addLocalWeeksToIso(dateIso: string, weeks: number): string {
  const date = new Date(dateIso);
  date.setDate(date.getDate() + weeks * 7);

  return date.toISOString();
}

export function getLocalDateKey(value: Date | string): string {
  const date = toDate(value);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

export function getLocalHourKey(value: Date | string): string {
  return toDate(value).getHours().toString();
}

export function getLocalDateIso(value: Date | string): string {
  const date = toDate(value);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

function toDate(value: Date | string): Date {
  return value instanceof Date ? value : new Date(value);
}
